export function loadScriptBase({
    src,
    document,
    abortSignal,
    onBeforeLoad,
}: {
    src: string
    document: Document
    abortSignal?: AbortSignal
    onBeforeLoad?: (script: HTMLScriptElement) => void
}): Promise<HTMLScriptElement> {
    let loaded = false
    return new Promise<HTMLScriptElement>((resolve, reject) => {
        const script = document.createElement('script')

        abortSignal?.addEventListener('abort', () => {
            if (loaded) {
                return
            }

            script.remove()
            reject(new Error('Script aborted'))
        })

        script.addEventListener('load', () => {
            loaded = true
            resolve(script)
        })

        script.addEventListener('error', (errorEvent) => {
            if (loaded) {
                return
            }

            script.remove()
            reject(errorEvent.error || new Error(errorEvent.message || 'Failed to load script'))
        })

        onBeforeLoad?.(script)

        script.src = src

        document.body.appendChild(script)
    })
}
